import { Grid, Typography } from '@mui/material';
import { BackButton } from '@tassat/button';
import { ApiPair as ApiPairIcon } from '@tassat/icon';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Header from 'Containers/header';
import { useAppSelector } from 'Reducers/store/hooks';
import { getAPIConnectionsFromFirm } from 'Selectors/apiFirms';
import { getFirmByFirmId } from 'Selectors/firms';
import { ApiFirmPageHeader } from 'SharedComponents/pageHeader';

import ApiConnectionFirm from './apiConnectionFirm';
import ApiConnectionsFirmGrid from './connectionsGrid';

import type { IApiFirmViewProps } from '.';

export function ApiFirmView (props: IApiFirmViewProps) {
    const {
        classes,
        match
    } = props;

    const firmId = match.params.firmId;
    const firm = useAppSelector((state) => getFirmByFirmId(state, firmId));
    const apiConnections = useAppSelector((state) => getAPIConnectionsFromFirm(state, firmId, undefined));

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Header />
            <Grid
                className={classes.backButtonContainer}
                item
            >
                <BackButton
                    links={{
                            to: '/admin/firms',
                            text: 'All Firms'
                        }}
                />
            </Grid>
            <Grid
                className={classes.headerContainer}
                container
                direction='row'
                item
                spacing={0}
                xs={12}
            >
                <Grid
                    item
                    xs={6}
                >
                    <ApiFirmPageHeader
                        firm={firm}
                    />
                </Grid>
            </Grid>
            <Grid
                className={classes.connectionsContainer}
                container
                direction='row'
                justifyContent='space-around'
                spacing={0}
            >
                <Grid
                    item
                    xs={3}
                >
                    <ApiConnectionsFirmGrid
                        apiConnections={apiConnections}
                    />
                </Grid>
                <Grid
                    container
                    direction='column'
                    item
                    spacing={0}
                    xs={8}
                >
                    <Switch>
                        <Route
                            exact
                            path='/admin/firms/:firmId/api/:apiConnFirmId'
                            render={props => (
                                <ApiConnectionFirm
                                    {...props}
                                />
                                )}
                        />
                        <Route
                            exact
                            path='/admin/firms/:firmId'
                            render={props => (
                                <Grid
                                    alignItems='center'
                                    className={classes.noSelectedConnection}
                                    container
                                    direction='column'
                                    item
                                    spacing={0}
                                    wrap='nowrap'
                                >
                                    <ApiPairIcon className={classes.apiIcon} />
                                    <Typography variant='body1'>Please select an API Connection</Typography>
                                </Grid>
                                )}
                        />
                    </Switch>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ApiFirmView;